document.addEventListener("DOMContentLoaded", () => {
    var makeup_options = document.querySelectorAll(".makeup-option .makeup-option-image");
    var selection_item_closes = document.querySelectorAll(".selection-item-content .selection-item-close");
    var animation_elements = document.querySelectorAll(".product-animation-video");
    var animation_thumbnails = document.querySelectorAll(".product-animation-video-thumbnail");
    var makeup_dropdown_buttons = document.querySelectorAll(".makeup-options-fields .makeup-dropdown-button");
    
    const getSelectionContent = () => document.querySelector(".selection-content");
    const getBundleRequiredCount = () => {
        const sc = getSelectionContent();
        return Math.max(0, parseInt(sc?.dataset?.selectionCount || '0', 10) || 0);
    };
    const getBundleSelectedCount = () => {
        const sc = getSelectionContent();
        return Math.max(0, parseInt(sc?.dataset?.count || '0', 10) || 0);
    };
    // Step 2 rule: solid limit = bundle required items - 1
    const getSolidLimit = () => {
        const required = getBundleRequiredCount();
        if (!required) return 6; // fallback for non-bundle pages
        return Math.max(0, required - 1);
    };
    const updateAddToCartButtonState = () => {
        const btn = document.querySelector(`.product__info-container .main-product-form .product-form__submit[data-type="makeup-option"]`);
        if (!btn) return;
        const required = getBundleRequiredCount();
        if (!required) return;
        const selected = getBundleSelectedCount();
        const isComplete = selected >= required;
        btn.disabled = !isComplete;
        if (!isComplete) btn.setAttribute('aria-disabled', 'true');
        else btn.removeAttribute('aria-disabled');
    };

    updateAddToCartButtonState();
    if(makeup_options) {
        makeup_options.forEach(makeup_option => {
            makeup_option.addEventListener("click", () => {
                var price_content = makeup_option.closest(".makeup-options-fields")?.querySelector(".makeup-subparent-label__value");
                var input_element = makeup_option.closest(".makeup-option")?.querySelector("input");
                var selection_content = document.querySelector(".selection-content");
                if (!selection_content) return; // Exit if no selection content

                var parent_label = makeup_option.dataset.parent;
                var top_parent = makeup_option.dataset.value;
                var top_parent_label = makeup_option.dataset.topParent; // This is the parent.label (liquid or solid)
                var count = selection_content.dataset.count;
                var total_count = selection_content.dataset.selectionCount;
                // Get display name if available, otherwise use value
                var display_name = makeup_option.dataset.displayName || top_parent;
                // Use display name for display purposes, but keep original value for data attributes
                var value = top_parent; // Keep original value for form submission
                
                // Determine selection limit based on parent.label
                var selection_limit = getSolidLimit(); // Default for solid
                if (top_parent_label && top_parent_label.toLowerCase() === "liquid") {
                    selection_limit = 1;
                } else if (top_parent_label && top_parent_label.toLowerCase() === "solid") {
                    selection_limit = getSolidLimit();
                }
                
                // Count how many options are currently selected for this parent label
                var parent_selected_count = 0;
                if (top_parent_label) {
                    // Count all active options with the same top_parent_label
                    makeup_options.forEach(option => {
                        if (option.classList.contains("active") && option.dataset.topParent === top_parent_label) {
                            parent_selected_count++;
                        }
                    });
                }
                var value = "";
                var top_parent_element = document.querySelector(`.product-animation-video[data-position='${top_parent}']`);
                var top_parent_thumbnail = document.querySelector(`.product-animation-video-thumbnail[data-position='${top_parent}']`);

                // Find and update corresponding dropdown
                const makeupOptionsFields = makeup_option.closest('.makeup-options-fields');
                if (makeupOptionsFields) {
                    const dropdown = makeupOptionsFields.querySelector('.makeup-dropdown');
                    if (dropdown) {
                        const buttonText = dropdown.querySelector('.makeup-dropdown-button-text');
                        if (buttonText) {
                            const buttonImage = buttonText.querySelector('img');
                            const buttonTextValue = buttonText.querySelector('.makeup-dropdown-button-text-value');
                            const totalValueElement = input_element?.closest('form')?.querySelector('#total_value');
                            
                            if (buttonImage && buttonTextValue) {
                                if (!makeup_option.classList.contains('active')) {
                                    // Update dropdown when option is selected
                                    const optionImage = makeup_option.querySelector('img');
                                    if (optionImage) {
                                        buttonImage.src = optionImage.src;
                                    }
                                    const currency = totalValueElement?.dataset?.currency || '';
                                    const price = makeup_option.dataset.price;
                                    const formattedPrice = price && !isNaN(parseFloat(price)) ? 
                                        parseFloat(price).toFixed(2) : '0.00';
                                    // Use display name if available, otherwise use value
                                    const displayName = makeup_option.dataset.displayName || makeup_option.dataset.value;
                                    buttonTextValue.textContent = `${displayName} | ${formattedPrice} ${currency}`;
                                    buttonText.classList.add('has-selection');
                                } else {
                                    // Reset dropdown when option is deselected
                                    buttonImage.src = '';
                                    buttonTextValue.textContent = `Select ${parent_label} option.`;
                                    buttonText.classList.remove('has-selection');
                                }
                            }
                        }
                    }
                }

                if(animation_elements && top_parent) {
                    // Show/hide slides based on selection with image preloading
                    animation_elements.forEach(animation => {
                        if(animation.dataset.position == top_parent) {
                            // Preload image before showing
                            var img = animation.querySelector('img');
                            if (img) {
                                var src = img.dataset.src || img.src;
                                if (src && (!img.complete || img.naturalHeight === 0)) {
                                    var imageLoader = new Image();
                                    imageLoader.onload = function() {
                                        if (img.dataset.src && img.src !== src) {
                                            img.src = src;
                                        }
                                        animation.classList.remove("hidden");
                                    };
                                    imageLoader.onerror = function() {
                                        animation.classList.remove("hidden");
                                    };
                                    imageLoader.src = src;
                                } else {
                                    animation.classList.remove("hidden");
                                }
                            } else {
                                animation.classList.remove("hidden");
                            }
                        } else if(animation.dataset.position !== 'main') {
                            // Hide other slides except main
                            animation.classList.add("hidden");
                        }
                    });
                }

                if(animation_thumbnails && top_parent_thumbnail) {
                    // Update active thumbnail
                    var active_thumbnail_element = document.querySelector(".product-animation-video-thumbnail.active");
                    if(active_thumbnail_element) {
                        active_thumbnail_element.classList.remove("active");
                    }
                    top_parent_thumbnail.classList.add("active");
                    
                    // Find the index of the thumbnail in the swiper
                    var thumbnails = Array.from(document.querySelectorAll('.product-animation-video-thumbnail'));
                    var thumbnailIndex = thumbnails.indexOf(top_parent_thumbnail);
                    
                    // Find the corresponding main slide index (after showing it)
                    var mainSlides = Array.from(document.querySelectorAll('.product-animation-video'));
                    var mainSlideIndex = -1;
                    mainSlides.forEach(function(slide, index) {
                        if (slide.dataset.position === top_parent) {
                            mainSlideIndex = index;
                        }
                    });
                    
                    // Sync both swipers
                    if (window.main_video && mainSlideIndex >= 0) {
                        window.main_video.slideTo(mainSlideIndex, 300);
                    }
                    
                    if (window.thumbnail_video && thumbnailIndex >= 0) {
                        window.thumbnail_video.slideTo(thumbnailIndex, 300);
                    }
                }
                if(input_element){
                    value = input_element.value.split('|')[0];
                }
                var price = makeup_option.dataset.price;
                if(makeup_option.classList.contains("active")){
                    makeup_option.classList.remove("active");
                    var active_option = makeup_option.closest(".makeup-options-content").querySelector(`.makeup-option .makeup-option-image[data-parent="${parent_label}"].active`);
                    var selection_item = document.querySelector(`.selection-content .selection-item[data-item='${value}']`);
                    if(selection_item) {
                        selection_item.innerHTML = '';
                        selection_item.classList.add("empty");
                        selection_item.setAttribute("data-item", "");
                        if (active_option) {
                            
                        }else {
                            selection_item.setAttribute("data-parent", "");
                        }
                    }
                    if(active_option) {
                        price_content.classList.remove("hidden");
                    }else {
                        price_content.classList.add("hidden");
                        selection_item.setAttribute("data-parent", "");
                        price_content.querySelector(".makeup_option_value").innerHTML = "";
                    }
                    selection_content.setAttribute("data-count", count - 1);
                    updateAddToCartButtonState();
                    
                    // Re-enable options for the parent label if limit is no longer reached
                    if (top_parent_label) {
                        var remaining_parent_count = parent_selected_count - 1;
                        if (remaining_parent_count < selection_limit) {
                            makeup_options.forEach(item => {
                                var item_top_parent = item.dataset.topParent;
                                if (item_top_parent === top_parent_label && !item.classList.contains("active")) {
                                    item.classList.remove("btn-disabled");
                                }
                            });
                            
                            // Re-enable dropdown buttons for this parent label
                            makeup_dropdown_buttons.forEach(button => {
                                var buttonFields = button.closest('.makeup-options-fields');
                                if (buttonFields) {
                                    var buttonOption = buttonFields.querySelector('.makeup-option-image');
                                    if (buttonOption && buttonOption.dataset.topParent === top_parent_label) {
                                        button.disabled = false;
                                    }
                                }
                            });
                        }
                    }
                    
                    // Also re-enable all options if total count allows
                    makeup_options.forEach(item => {
                        if(!item.classList.contains("active")){
                            // Only remove disabled if not disabled by parent label limit
                            var item_top_parent = item.dataset.topParent;
                            if (item_top_parent && top_parent_label) {
                                // Count remaining selections for this item's parent
                                var itemParentCount = 0;
                                makeup_options.forEach(option => {
                                    if (option.classList.contains("active") && option.dataset.topParent === item_top_parent) {
                                        itemParentCount++;
                                    }
                                });
                                var itemLimit = item_top_parent.toLowerCase() === "liquid" ? 1 : getSolidLimit();
                                if (itemParentCount < itemLimit) {
                                    item.classList.remove("btn-disabled");
                                }
                            } else {
                                item.classList.remove("btn-disabled");
                            }
                        }
                    });
                    
                    // Re-enable dropdown buttons that aren't at their limit
                    makeup_dropdown_buttons.forEach(button => {
                        var buttonFields = button.closest('.makeup-options-fields');
                        if (buttonFields) {
                            var buttonOption = buttonFields.querySelector('.makeup-option-image');
                            if (buttonOption) {
                                var buttonTopParent = buttonOption.dataset.topParent;
                                if (buttonTopParent) {
                                    // Count selections for this button's parent
                                    var buttonParentCount = 0;
                                    var allSelectedForButton = document.querySelectorAll(".selection-content .selection-item:not(.empty)");
                                    allSelectedForButton.forEach(selItem => {
                                        var selValue = selItem.dataset.item;
                                        if (selValue) {
                                            var selOption = document.querySelector(`.makeup-option-image[data-value="${selValue}"]`);
                                            if (selOption && selOption.dataset.topParent === buttonTopParent) {
                                                buttonParentCount++;
                                            }
                                        }
                                    });
                                    var buttonLimit = buttonTopParent.toLowerCase() === "liquid" ? 1 : getSolidLimit();
                                    if (buttonParentCount < buttonLimit) {
                                        button.disabled = false;
                                    }
                                } else {
                                    button.disabled = false;
                                }
                            } else {
                                button.disabled = false;
                            }
                        }
                    });
                    
                  var value_element = price_content.querySelector(".makeup_option_value");
                  var price_element = price_content.querySelector(".makeup_option_price");
                  if(makeup_option.closest(".makeup-options-fields").dataset.type == "checkbox") {
                      var total_value_element = makeup_option.closest(".makeup-options").querySelector("#total_value");
                      var original_value = value_element.innerHTML;
                      var total_value = "";
                      var total_price = "";
                      // Get display name for comparison
                      var displayName = makeup_option.dataset.displayName || value;
                      // Compare using display names in the HTML, but use original values for form data
                      if(original_value == displayName || original_value == value){
                          value_element.innerHTML = original_value.replace(displayName, "").replace(value, "").replace(/^,\s*|,\s*$/g, "");
                          // Find the original value in the original_value string to remove it
                          var originalDisplayValue = original_value.split(",").find(v => v.trim() == displayName || v.trim() == value);
                          if(originalDisplayValue) {
                              total_value = original_value.replace(originalDisplayValue.trim(), "").replace(/^,\s*|,\s*$/g, "");
                          } else {
                              total_value = original_value.replace(value, "").replace(/^,\s*|,\s*$/g, "");
                          }
                      }else {
                          var remove_value = "";
                          // Check if value or displayName is at the start
                          var firstValue = original_value.split(",")[0].trim();
                          if(value == firstValue || displayName == firstValue) {
                              remove_value = firstValue + ",";
                          }else {
                              // Find and remove the matching value (could be display name or original value)
                              var values = original_value.split(",");
                              var foundIndex = -1;
                              for(var i = 0; i < values.length; i++) {
                                  if(values[i].trim() == displayName || values[i].trim() == value) {
                                      foundIndex = i;
                                      break;
                                  }
                              }
                              if(foundIndex > 0) {
                                  remove_value = "," + values[foundIndex].trim();
                              } else if(foundIndex == 0) {
                                  remove_value = values[foundIndex].trim() + ",";
                              }
                          }
                          value_element.innerHTML = original_value.replace(remove_value, "").replace(/^,\s*|,\s*$/g, "");
                          total_value = original_value.replace(remove_value, "").replace(/^,\s*|,\s*$/g, "");
                      }
                      var original_price = price_element.innerHTML ? parseFloat(price_element.innerHTML) : 0;
                      var price_value = parseFloat(price) || 0;
                      var new_price = (original_price - price_value).toFixed(2);
                      price_element.innerHTML = new_price;
                      if(total_value_element){
                          if(total_value == ""){
                              total_value_element.value = "";
                          }else {
                              total_value_element.value = total_value + " | " + total_price + " " + total_value_element.dataset.currency;
                          }
                      }
                  }
                }else {
                    var value_element = price_content.querySelector(".makeup_option_value");
                    var price_element = price_content.querySelector(".makeup_option_price");
                    if(makeup_option.closest(".makeup-option").dataset.type == "radio"){
                        var active_option = makeup_option.closest(".makeup-options-content").querySelector(`.makeup-option .makeup-option-image[data-parent="${parent_label}"].active`);
                        var is_switching_radio = false;
                        if(active_option){
                            // For radio buttons, switching between options in same subparent is allowed
                            is_switching_radio = true;
                            active_option.classList.remove("active");
                            var active_input = active_option.closest(".makeup-options-content").querySelector(".makeup-option input");
                            if(active_input) {
                                active_input.checked = false;
                                var active_input_value = active_input.value.split("|")[0];
                                active_input_value = active_input_value.split(" ").slice(0, -1).join(" ");
                            }
                        }
                        
                        // For radio buttons, also check if we're switching between options from different subparents but same top parent
                        // If limit is reached and we're not switching within the same subparent, check if we can switch from another subparent
                        if (top_parent_label && !is_switching_radio && parent_selected_count >= selection_limit) {
                            // Check if there's an active option with the same top_parent that we can switch from
                            var switchable_option = null;
                            makeup_options.forEach(option => {
                                if (option.classList.contains("active") && 
                                    option.dataset.topParent === top_parent_label && 
                                    option !== makeup_option) {
                                    switchable_option = option;
                                }
                            });
                            
                            if (!switchable_option) {
                                // No option to switch from, limit reached, prevent selection
                                return;
                            }
                            
                            // Deselect the switchable option to allow the switch
                            switchable_option.classList.remove("active");
                            var switchable_input = switchable_option.closest(".makeup-option")?.querySelector("input");
                            if (switchable_input) {
                                switchable_input.checked = false;
                            }
                            
                            // Update the selection item if it exists
                            var switchable_value = switchable_input ? switchable_input.value.split("|")[0] : "";
                            switchable_value = switchable_value.split(" ").slice(0, -1).join(" ");
                            var switchable_selection_item = document.querySelector(`.selection-content .selection-item[data-item='${switchable_value}']`);
                            if (switchable_selection_item) {
                                switchable_selection_item.innerHTML = '';
                                switchable_selection_item.classList.add("empty");
                                switchable_selection_item.setAttribute("data-item", "");
                                switchable_selection_item.setAttribute("data-parent", "");
                            }
                            
                            // Update count
                            var switchable_parent_label = switchable_option.dataset.parent;
                            var switchable_price_content = switchable_option.closest(".makeup-options-fields")?.querySelector(".makeup-subparent-label__value");
                            if (switchable_price_content) {
                                var switchable_value_element = switchable_price_content.querySelector(".makeup_option_value");
                                var switchable_price_element = switchable_price_content.querySelector(".makeup_option_price");
                                if (switchable_value_element) {
                                    switchable_value_element.innerHTML = "";
                                }
                                if (switchable_price_element) {
                                    switchable_price_element.innerHTML = "0.00";
                                }
                                switchable_price_content.classList.add("hidden");
                            }
                        }
                        // Use display name for display
                        var displayName = makeup_option.dataset.displayName || value;
                        value_element.innerHTML = displayName;
                        var price_value = parseFloat(price) || 0;
                        price_element.innerHTML = price_value.toFixed(2);
                        makeup_option.classList.add("active");
                        var parent_selected_item = document.querySelector(`.selection-content .selection-item[data-parent='${parent_label}']`);
                        if(parent_selected_item){
                            parent_selected_item.innerHTML = makeup_option.innerHTML;
                            parent_selected_item.setAttribute("data-item", value);
                        }else {
                            var empty_selection_item = document.querySelector(".selection-content .selection-item.empty");
                            if(empty_selection_item) {
                                empty_selection_item.innerHTML = makeup_option.innerHTML;
                                empty_selection_item.classList.remove("empty");
                                empty_selection_item.setAttribute("data-item", value);
                                empty_selection_item.setAttribute("data-parent", parent_label);
                                var current_count = parseInt(count) + parseInt(1)
                                selection_content.setAttribute("data-count", current_count);
                                updateAddToCartButtonState();
                                
                                // Update parent selected count after adding this selection
                                var new_parent_selected_count = parent_selected_count + 1;
                                
                                // Disable options for this parent label if limit is reached
                                if (top_parent_label && new_parent_selected_count >= selection_limit) {
                                    makeup_options.forEach(item => {
                                        var item_top_parent = item.dataset.topParent;
                                        if (item_top_parent === top_parent_label && !item.classList.contains("active")) {
                                            item.classList.add("btn-disabled");
                                        }
                                    });
                                    
                                    // Disable dropdown buttons for this parent label
                                    makeup_dropdown_buttons.forEach(button => {
                                        var buttonFields = button.closest('.makeup-options-fields');
                                        if (buttonFields) {
                                            var buttonOption = buttonFields.querySelector('.makeup-option-image');
                                            if (buttonOption && buttonOption.dataset.topParent === top_parent_label) {
                                                button.disabled = true;
                                            }
                                        }
                                    });
                                }
                                
                                // Also check total count for overall limit
                                if(total_count == current_count) {
                                    makeup_options.forEach(item => {
                                        if(!item.classList.contains("active")){
                                            item.classList.add("btn-disabled");
                                        }else {
                                            item.classList.remove("btn-disabled");
                                        }
                                    })
                                    makeup_dropdown_buttons.forEach(button => {
                                        button.disabled = true;
                                    });
                                }else {
                                    // Only re-enable buttons that aren't disabled by parent label limit
                                    makeup_dropdown_buttons.forEach(button => {
                                        var buttonFields = button.closest('.makeup-options-fields');
                                        if (buttonFields) {
                                            var buttonOption = buttonFields.querySelector('.makeup-option-image');
                                            if (buttonOption) {
                                                var buttonTopParent = buttonOption.dataset.topParent;
                                                if (buttonTopParent) {
                                                    // Count selections for this button's parent
                                                    var buttonParentCount = 0;
                                                    var allSelectedForButton = document.querySelectorAll(".selection-content .selection-item:not(.empty)");
                                                    allSelectedForButton.forEach(selItem => {
                                                        var selValue = selItem.dataset.item;
                                                        if (selValue) {
                                                            var selOption = document.querySelector(`.makeup-option-image[data-value="${selValue}"]`);
                                                            if (selOption && selOption.dataset.topParent === buttonTopParent) {
                                                                buttonParentCount++;
                                                            }
                                                        }
                                                    });
                                                    var buttonLimit = buttonTopParent.toLowerCase() === "liquid" ? 1 : getSolidLimit();
                                                    if (buttonParentCount < buttonLimit && total_count != current_count) {
                                                        button.disabled = false;
                                                    }
                                                } else if (total_count != current_count) {
                                                    button.disabled = false;
                                                }
                                            } else if (total_count != current_count) {
                                                button.disabled = false;
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }else {
                        // Check if selection limit is reached for this parent label (for checkbox type)
                        if (top_parent_label && !makeup_option.classList.contains("active")) {
                            if (parent_selected_count >= selection_limit) {
                                // Limit reached, prevent selection
                                return;
                            }
                        }
                        
                        makeup_option.classList.add("active");
                        var total_value_element = makeup_option.closest(".makeup-options").querySelector("#total_value");
                        var original_value = value_element.innerHTML;
                        var total_value = "";
                        var total_price = "";
                        if(original_value == "") {
                            // Use display name for display
                            var displayName = makeup_option.dataset.displayName || value;
                            value_element.innerHTML = displayName;
                            total_value = value; // Keep original value for form
                        }else {
                            // Use display name for display
                            var displayName = makeup_option.dataset.displayName || value;
                            value_element.innerHTML = original_value + "," + displayName;
                            total_value = original_value + "," + value; // Keep original value for form
                        }
                        var original_price = price_element.innerHTML ? parseFloat(price_element.innerHTML) : 0;
                        var price_value = parseFloat(price) || 0;
                        var new_price = (original_price + price_value).toFixed(2);
                        price_element.innerHTML = new_price;
                        if(total_value_element){
                            total_value_element.value = total_value + " | " + total_price + " " + total_value_element.dataset.currency;
                        }
                        var empty_selection_item = document.querySelector(".selection-content .selection-item.empty");
                        if(empty_selection_item) {
                            empty_selection_item.innerHTML = makeup_option.innerHTML;
                            empty_selection_item.classList.remove("empty");
                            empty_selection_item.setAttribute("data-item", value);
                            empty_selection_item.setAttribute("data-parent", parent_label);
                            var current_count = parseInt(count) + parseInt(1)
                            selection_content.setAttribute("data-count", current_count);
                            updateAddToCartButtonState();
                            
                            // Update parent selected count after adding this selection
                            var new_parent_selected_count = parent_selected_count + 1;
                            
                            // Disable options for this parent label if limit is reached
                            if (top_parent_label && new_parent_selected_count >= selection_limit) {
                                makeup_options.forEach(item => {
                                    var item_top_parent = item.dataset.topParent;
                                    if (item_top_parent === top_parent_label && !item.classList.contains("active")) {
                                        item.classList.add("btn-disabled");
                                    }
                                });
                                
                                // Disable dropdown buttons for this parent label
                                makeup_dropdown_buttons.forEach(button => {
                                    var buttonFields = button.closest('.makeup-options-fields');
                                    if (buttonFields) {
                                        var buttonOption = buttonFields.querySelector('.makeup-option-image');
                                        if (buttonOption && buttonOption.dataset.topParent === top_parent_label) {
                                            button.disabled = true;
                                        }
                                    }
                                });
                            }
                            
                            // Also check total count for overall limit
                            if(total_count == current_count) {
                                makeup_options.forEach(item => {
                                    if(!item.classList.contains("active")){
                                        item.classList.add("btn-disabled");
                                    }else {
                                        item.classList.remove("btn-disabled");
                                    }
                                })
                                makeup_dropdown_buttons.forEach(button => {
                                    button.disabled = true;
                                });
                            }else {
                                // Only re-enable buttons that aren't disabled by parent label limit
                                makeup_dropdown_buttons.forEach(button => {
                                    var buttonFields = button.closest('.makeup-options-fields');
                                    if (buttonFields) {
                                        var buttonOption = buttonFields.querySelector('.makeup-option-image');
                                        if (buttonOption) {
                                            var buttonTopParent = buttonOption.dataset.topParent;
                                            if (buttonTopParent) {
                                                // Count selections for this button's parent
                                                var buttonParentCount = 0;
                                                makeup_options.forEach(option => {
                                                    if (option.classList.contains("active") && option.dataset.topParent === buttonTopParent) {
                                                        buttonParentCount++;
                                                    }
                                                });
                                                var buttonLimit = buttonTopParent.toLowerCase() === "liquid" ? 1 : getSolidLimit();
                                                if (buttonParentCount < buttonLimit && total_count != current_count) {
                                                    button.disabled = false;
                                                }
                                            } else if (total_count != current_count) {
                                                button.disabled = false;
                                            }
                                        } else if (total_count != current_count) {
                                            button.disabled = false;
                                        }
                                    }
                                });
                            }
                        }
                    }
                    price_content.classList.remove("hidden");
                }
            })
        })
    }
    if(animation_thumbnails) {
        animation_thumbnails.forEach((thumbnail, thumbIndex) => {
            thumbnail.addEventListener("click", (e) => {
                // Prevent event bubbling to avoid conflicts
                e.stopPropagation();
                var data_position = thumbnail.dataset.position;
                
                // Find the corresponding main slide
                var mainSlides = Array.from(document.querySelectorAll('.product-animation-video'));
                var targetMainIndex = -1;
                
                // First, find the target slide index
                mainSlides.forEach((slide, slideIndex) => {
                    if (slide.dataset.position === data_position) {
                        targetMainIndex = slideIndex;
                    }
                });
                
                // Show/hide slides appropriately with image preloading
                mainSlides.forEach((slide, slideIndex) => {
                    if (slide.dataset.position === data_position) {
                        // Preload image before showing
                        var img = slide.querySelector('img');
                        if (img) {
                            var src = img.dataset.src || img.src;
                            if (src && (!img.complete || img.naturalHeight === 0)) {
                                var imageLoader = new Image();
                                imageLoader.onload = function() {
                                    if (img.dataset.src && img.src !== src) {
                                        img.src = src;
                                    }
                                    slide.classList.remove("hidden");
                                };
                                imageLoader.onerror = function() {
                                    slide.classList.remove("hidden");
                                };
                                imageLoader.src = src;
                            } else {
                                slide.classList.remove("hidden");
                            }
                        } else {
                            slide.classList.remove("hidden");
                        }
                        
                        var video = slide.querySelector("video");
                        if (video) {
                            video.play().catch(function() {
                                // Video play failed, ignore
                            });
                        }
                    } else if (slide.dataset.position !== 'main') {
                        // Hide other slides except main
                        slide.classList.add("hidden");
                        var video = slide.querySelector("video");
                        if (video) {
                            video.pause();
                        }
                    }
                });
                
                // Update active states
                animation_thumbnails.forEach(thumb => {
                    thumb.classList.remove("active");
                });
                thumbnail.classList.add("active");
                
                // Sync both swipers
                if (window.main_video && targetMainIndex >= 0) {
                    window.main_video.slideTo(targetMainIndex, 300);
                }
                
                if (window.thumbnail_video && thumbIndex >= 0) {
                    window.thumbnail_video.slideTo(thumbIndex, 300);
                }
            })
        })
    }
    if (selection_item_closes) {
        selection_item_closes.forEach(selection_item_close => {
            selection_item_close.addEventListener("click", () => {
                var selection_item = selection_item_close.closest('.selection-item-content').querySelector(".selection-item");
                var selection_content = selection_item_close.closest('.selection-content');
                var selection_count = selection_content.dataset.count;
                var selection_value = selection_item.dataset.item;
                var parent_label = selection_item.dataset.parent;
                selection_value = selection_value.split(" ").slice(0, -1).join(" ");
                selection_content.setAttribute('data-count', selection_count - 1);
                updateAddToCartButtonState();
                selection_item.innerHTML = '';
                selection_item.classList.add("empty");
                selection_item.setAttribute("data-item", "");
                selection_item.setAttribute("data-parent", "");

                // Find and reset the corresponding dropdown
                if (parent_label) {
                    const makeupOptionsFields = Array.from(document.querySelectorAll('.makeup-options-fields')).find(field => {
                        const label = field.querySelector('.makeup-subparent-label');
                        return label && label.textContent.trim() === parent_label;
                    });
                    
                    if (makeupOptionsFields) {
                        const dropdown = makeupOptionsFields.querySelector('.makeup-dropdown');
                        if (dropdown) {
                            const buttonText = dropdown.querySelector('.makeup-dropdown-button-text');
                            if (buttonText) {
                                const buttonImage = buttonText.querySelector('img');
                                const buttonTextValue = buttonText.querySelector('.makeup-dropdown-button-text-value');
                                
                                // Reset dropdown state
                                buttonImage.src = '';
                                buttonTextValue.textContent = `Select ${parent_label} option.`;
                                buttonText.classList.remove('has-selection');
                            }
                        }
                    }
                }

                var active_makeup_image = document.querySelector(`.makeup-option-image[data-value="${selection_value}"]`);
                var removed_top_parent = null;
                if (active_makeup_image) {
                    active_makeup_image.classList.remove("active");
                    removed_top_parent = active_makeup_image.dataset.topParent;
                }
                
                // Re-enable options based on parent label limits
                makeup_options.forEach(item => {
                    var item_top_parent = item.dataset.topParent;
                    if (item_top_parent && removed_top_parent) {
                        // Count remaining selections for this item's parent
                        var itemParentCount = 0;
                        makeup_options.forEach(option => {
                            if (option.classList.contains("active") && option.dataset.topParent === item_top_parent) {
                                itemParentCount++;
                            }
                        });
                        var itemLimit = item_top_parent.toLowerCase() === "liquid" ? 1 : getSolidLimit();
                        if (itemParentCount < itemLimit && !item.classList.contains("active")) {
                            item.classList.remove("btn-disabled");
                        }
                    } else if (item.classList.contains("btn-disabled") && !item.classList.contains("active")) {
                        item.classList.remove("btn-disabled");
                    }
                });
                
                // Re-enable dropdown buttons that aren't at their limit
                makeup_dropdown_buttons.forEach(button => {
                    var buttonFields = button.closest('.makeup-options-fields');
                    if (buttonFields) {
                        var buttonOption = buttonFields.querySelector('.makeup-option-image');
                        if (buttonOption) {
                            var buttonTopParent = buttonOption.dataset.topParent;
                            if (buttonTopParent) {
                                // Count selections for this button's parent
                                var buttonParentCount = 0;
                                makeup_options.forEach(option => {
                                    if (option.classList.contains("active") && option.dataset.topParent === buttonTopParent) {
                                        buttonParentCount++;
                                    }
                                });
                                var buttonLimit = buttonTopParent.toLowerCase() === "liquid" ? 1 : getSolidLimit();
                                if (buttonParentCount < buttonLimit) {
                                    button.disabled = false;
                                }
                            } else {
                                button.disabled = false;
                            }
                        } else {
                            button.disabled = false;
                        }
                    }
                });
            });
        });
    }
    var submit_button = document.querySelector(`.product__info-container .main-product-form .product-form__submit[data-type="makeup-option"]`);
    if (submit_button) {
        var cartDrawerElement = document.querySelector('cart-drawer');
        submit_button.addEventListener("click", (e) => {
            
            e.preventDefault();
            // Enforce bundle completeness (request-side protection)
            const requiredSelections = getBundleRequiredCount();
            if (requiredSelections) {
                const selectedSelections = getBundleSelectedCount();
                if (selectedSelections < requiredSelections) return;
            }
            var form = submit_button.closest(".main-product-form");
            var active_variants = document.querySelectorAll(".makeup-option .makeup-option-image.active");
            const normalizeVariantId = (raw) => {
                if (raw == null) return null;
                const str = String(raw).trim();
                if (!str) return null;
                const gidMatch = str.match(/ProductVariant\/(\d+)/);
                if (gidMatch && gidMatch[1]) return gidMatch[1];
                const digits = str.match(/\d+/g);
                if (!digits) return str;
                // If it's already a plain numeric id, keep it. If it's a gid, we already handled above.
                return digits.join('');
            };

            const buildMainItemFromForm = (productForm) => {
                if (!productForm) return null;
                const idInput = productForm.querySelector('input[name="id"]');
                const quantityInput = productForm.querySelector('input[name="quantity"]');
                const sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');

                const id = normalizeVariantId(idInput?.value);
                if (!id) return null;

                const quantityRaw = quantityInput?.value;
                const quantity = Math.max(1, parseInt(quantityRaw || '1', 10) || 1);

                const item = { id, quantity };
                const sellingPlan = normalizeVariantId(sellingPlanInput?.value);
                if (sellingPlan) item.selling_plan = sellingPlan;
                return item;
            };

            var add_data = { 'items': [] };
            const mainItem = buildMainItemFromForm(form);
            if (!mainItem) {
                // If we can't resolve a valid variant id, don't call cart API.
                return;
            }
            add_data.items.push(mainItem);
            if(active_variants) {
                active_variants.forEach(variant => {
                    var variant_id = normalizeVariantId(variant.dataset.id);
                    if (!variant_id) return;
                    var variant_data = {
                        'id': variant_id,
                        'quantity': 1
                    }
                    add_data.items.push(variant_data);
                })
            }
            var lastSubmittedElement = e.submitter || e.currentTarget;
            let sectionsToBundle = [];
            document.documentElement.dispatchEvent(
            new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
            );
            add_data.sections = sectionsToBundle;
            add_data.sections_url = window.location.pathname;
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(add_data)
              })
              .then(response => {
                return response.json();
              })
              .then(async (parsedState) => {
                if (parsedState.status) {
                    return;
                }
                const cartJson = await (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })).json();
                cartJson['sections'] = parsedState['sections'];
                FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
                document.dispatchEvent(
                    new CustomEvent('product-ajax:added', {
                      detail: {
                        product: parsedState,
                      },
                    })
                  );
                cartDrawerElement && cartDrawerElement.show(lastSubmittedElement);
              })
              .catch((error) => {
                console.error('Error:', error);
              });
        })
    }
})